import { IthacaJwt, fetchClaimsFromIthaca } from '../auth'
import { decodeFronteggAccessToken } from './decodeFronteggAccessToken'
import { logger } from '@dtx-company/logger'
import { refreshFronteggTokens } from './refreshFronteggTokens'

export async function buildJwtFromFronteggAccessToken(
  fronteggAccessToken: string
): Promise<IthacaJwt | undefined> {
  try {
    let decodedAccessToken = decodeFronteggAccessToken(fronteggAccessToken)

    // Try one time to refresh the token
    if (!decodedAccessToken?.customClaims) {
      const token = await refreshFronteggTokens()
      if (token.accessToken) {
        decodedAccessToken = decodeFronteggAccessToken(token.accessToken)

        if (!decodedAccessToken?.customClaims) {
          throw new Error('decode access token retry (1) - no customClaims even after retry')
        }
      } else {
        throw new Error('decode access token retry (1) - token.accessToken does not exist')
      }
    }

    if (decodedAccessToken) {
      const claims = await fetchClaimsFromIthaca(decodedAccessToken?.customClaims?.ithacaId, true)
      if (claims && claims.ithacaId) {
        return {
          ...claims,
          token: fronteggAccessToken
        }
      } else if (!claims) {
        throw new Error(
          'Failed to build JWT from Frontegg Access Token - no user data returned from Ithaca'
        )
      } else if (!claims.ithacaId) {
        throw new Error(
          'Failed to build JWT from Frontegg Access Token - no Ithaca ID returned from Ithaca'
        )
      }
    }
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
